import Vue from 'vue'
import Meta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
// import '@fortawesome/fontawesome-free/js/all.js'
import './registerServiceWorker'

// PRODUCTION
Vue.config.devtools = false
Vue.config.productionTip = false

// DEVELOPMENT
// Vue.config.devtools = true
// Vue.config.productionTip = true

Vue.use(Meta)
Vue.use(VueI18n)
Vue.use(require('vue-moment'));
// Bootstrap
Vue.use(BootstrapVue);

let userLang = navigator.language
userLang = userLang.split('-')[0]
// userLang = 'de'

const lang = localStorage.getItem('locale')
if (lang && userLang !== lang) userLang = lang
const i18n = new VueI18n({
  locale: userLang,
  fallbackLocale: 'de'
})

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');

